import React, { useEffect, useState } from 'react';
import { startVersionWatcher, stopVersionWatcher } from '../../hooks/versionService';
import { UpdateBanner } from '../UpdateBanner/UpdateBanner';

interface Props {
  children: React.ReactNode;
}

export function AppUpdateShell({ children }: Props) {
  const [showUpdateBanner, setShowUpdateBanner] = useState(false);

  useEffect(() => {
    startVersionWatcher(() => {
      setShowUpdateBanner(true);
    });
    return () => stopVersionWatcher();
  }, []);

  const onRefreshNow = () => {
    const url = new URL(window.location.href);
    url.searchParams.set('v', Date.now().toString());
    window.location.replace(url.toString());
  };

  return (
    <>
      {children}
      {showUpdateBanner && <UpdateBanner onRefreshNow={onRefreshNow} />}
    </>
  );
}
